import { MessageCircle } from "lucide-react";
import { services } from "@/data/services";
import { business } from "@/config/business";
import { getWhatsAppUrl } from "@/lib/whatsapp";
import { trackEvent, EVENTS } from "@/lib/tracking";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export const ServicesSection = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="02"
          kicker="Layanan SEJUKARA"
          title="AC, HVAC, Electrical, Instalasi & Maintenance"
          description="Rangkaian layanan SEJUKARA untuk kebutuhan rumah, bisnis, gedung, dan fasilitas komersial."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
            const Icon = service.icon;
            const message = `Hallo CV Angkasa Briliant, saya ingin berkonsultasi mengenai layanan ${service.title} dari SEJUKARA.`;
            return (
              <Reveal key={service.id} delay={(i % 3) * 0.08}>
                <article
                  data-testid={`service-card-${service.id}`}
                  className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-slate-300 hover:shadow-[0_18px_40px_-16px_rgba(15,23,42,0.18)]"
                >
                  <span className="flex h-13 w-13 items-center justify-center rounded-xl bg-[#0F172A] p-3 text-white transition-colors duration-300 group-hover:bg-[#25D366]">
                    <Icon className="h-6 w-6" />
                  </span>
                  <h3 className="mt-6 text-lg font-bold text-slate-900">
                    {service.title}
                  </h3>
                  <p className="mt-2.5 text-[15px] leading-relaxed text-slate-600">
                    {service.description}
                  </p>
                  {service.items && (
                    <div className="mt-4 flex flex-1 flex-wrap content-start gap-1.5">
                      {service.items.map((it) => (
                        <span
                          key={it}
                          className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-600"
                        >
                          {it}
                        </span>
                      ))}
                    </div>
                  )}
                  <a
                    href={getWhatsAppUrl(message)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      trackEvent(EVENTS.WHATSAPP_CLICK, {
                        source: "service_card",
                        service: service.id,
                      })
                    }
                    data-testid={`service-cta-${service.id}`}
                    className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[#0F172A] transition-colors hover:text-[#25D366]"
                  >
                    <MessageCircle className="h-4 w-4" />
                    {business.cta.serviceCard}
                  </a>
                </article>
              </Reveal>
            );
          })}

          {/* CTA tile */}
          <Reveal delay={0.16}>
            <div className="flex h-full flex-col justify-between rounded-2xl bg-[#0F172A] p-7 text-white">
              <div>
                <h3 className="text-lg font-bold">Butuh layanan lain?</h3>
                <p className="mt-2.5 text-[15px] leading-relaxed text-slate-300">
                  Konsultasikan kebutuhan maintenance AC &amp; HVAC perusahaan
                  Anda. Tim kami siap membantu.
                </p>
              </div>
              <a
                href={getWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackEvent(EVENTS.WHATSAPP_CLICK, { source: "service_cta_tile" })
                }
                data-testid="service-cta-tile"
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg bg-[#25D366] px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-[#1eb85a]"
              >
                <MessageCircle className="h-4 w-4" />
                Chat via WhatsApp
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
